import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './media.css';
import App from './App';
import fbconfig from './fbconfig';
import { initializeApp } from "firebase/app";
import { getDatabase } from 'firebase/database';

const app = initializeApp(fbconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export const db = getDatabase(app);